module.exports = __webpack_public_path__ + "media/country_flags/mv-32495de0.png";